import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CustomOverlayContainer extends OverlayContainer {
    private document = inject(DOCUMENT);

    override _createContainer(): void {
        super._createContainer();

        // Encuentra el web component y su shadowRoot
        const shadowHost = this.document.querySelector('booking-widget'); // Cambia esto por el selector real
        if (shadowHost?.shadowRoot) {
            shadowHost.shadowRoot.appendChild(this._containerElement);
        }
    }
}
